/* esm.sh - @internetarchive/ia-clearable-text-input@1.2.0 */
import{__decorate as e}from"/tslib?target=es2022";import{html as u,css as d,nothing as a,LitElement as l}from"/lit@^2.2.7%20||%20^3.3.2?target=es2022";import{property as n,query as c,customElement as h}from"/lit@^2.2.7%20||%20^3.3.2/decorators?target=es2022";import"/@internetarchive/icon-close@^1.4.1?target=es2022";var t=class extends l{constructor(){super(...arguments),this.value="",this.clearButtonScreenReaderLabel="Clear",this.focusOnClear=!0,this.forceClearButton=!1}render(){var o,r,i,p;let s=!this.value&&!this.forceClearButton;return u`
      <div id="container">
        <slot name="icon"></slot>
        <label for="text-input" class="sr-only"
          >${(o=this.screenReaderLabel)!==null&&o!==void 0?o:a}</label
        >
        <input
          id="text-input"
          type="text"
          inputmode="search"
          enterkeyhint="search"
          autocapitalize="off"
          placeholder=${(r=this.placeholder)!==null&&r!==void 0?r:a}
          .value=${(i=this.value)!==null&&i!==void 0?i:a}
          aria-controls=${(p=this.ariaControls)!==null&&p!==void 0?p:a}
          @input=${this.onTextInput}
          @keypress=${this.onKeyPress}
        />
        <button
          id="clear-button"
          type="button"
          ?hidden=${s}
          @click=${this.clearButtonClicked}
        >
          <ia-icon-close aria-hidden="true"></ia-icon-close>
          <span class="sr-only">${this.clearButtonScreenReaderLabel}</span>
        </button>
      </div>
    `}onTextInput(){this.value=this.textInput.value}onKeyPress(o){if(o.key==="Enter"){this.textInput.blur();let r=new CustomEvent("submit",{detail:this.value});this.dispatchEvent(r)}}clearButtonClicked(){let o=this.textInput.value;this.value="",this.focusOnClear&&this.textInput.focus();let r=new CustomEvent("clear",{detail:o});this.dispatchEvent(r);let i=new InputEvent("input",{inputType:"deleteContentBackward"});this.dispatchEvent(i)}};t.shadowRootOptions={...l.shadowRootOptions,delegatesFocus:!0};t.styles=d`
    :host {
      --input-height: 3rem;
      --clear-button-top: 0;
      --clear-button-right: 2px;
    }

    #container {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: var(--input-height);
    }

    #text-input {
      width: 100%;
      height: 100%;
      padding: var(--input-padding, 0 1rem);
      padding-inline-end: var(--input-height);
      border: var(--input-border-width, 1px) var(--input-border-style, solid)
        var(--input-border-color, #ccc);
      border-radius: var(--input-border-radius, 2rem);
      background-image: var(--input-background-image, none);
      background-color: var(--input-background-color, transparent);
      color: var(--input-color, #555);
      font-size: var(--input-font-size, 1.7rem);
      line-height: var(--input-line-height, 1.5);
      box-shadow: var(--input-box-shadow, inset 0 1px 1px rgba(0, 0, 0, 0.075));
      -webkit-box-shadow: var(
        --input-box-shadow,
        inset 0 1px 1px rgba(0, 0, 0, 0.075)
      );
    }

    #text-input:focus {
      border-color: var(--input-focused-border-color, #66afe9);
      outline: 0;
      box-shadow: var(
        --input-focused-box-shadow,
        inset 0 1px 1px rgb(0 0 0 / 8%),
        0 0 8px rgb(102 175 233 / 60%)
      );
      -webkit-box-shadow: var(
        --input-focused-box-shadow,
        inset 0 1px 1px rgb(0 0 0 / 8%),
        0 0 8px rgb(102 175 233 / 60%)
      );
    }

    #clear-button {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      inset-block-start: var(--clear-button-top);
      inset-inline-end: var(--clear-button-right);
      height: var(--clear-button-height, var(--input-height));
      width: var(--clear-button-width, var(--input-height));
      padding: var(--clear-button-padding, 4px);
      border: var(--clear-button-border, 0);
      background: none;
      appearance: none;
      cursor: pointer;
    }

    #clear-button[hidden] {
      display: none;
    }

    ia-icon-close {
      --iconWidth: 100%;
      --iconHeight: 100%;
      --iconFillColor: white;
      background: #2c2c2c;
      border-radius: 50%;
      pointer-events: none;
    }

    /* Fallback support for older browsers without newer bidirectional rules */
    @supports not ((inset-block-start: 0) and (padding-inline-end: 0)) {
      #text-input {
        padding-right: var(--input-height);
      }

      #clear-button {
        top: var(--clear-button-top);
        right: var(--clear-button-right);
      }
    }

    .sr-only {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      margin: -1px !important;
      padding: 0 !important;
      border: 0 !important;
      overflow: hidden !important;
      white-space: nowrap !important;
      clip: rect(1px, 1px, 1px, 1px) !important;
      -webkit-clip-path: inset(50%) !important;
      clip-path: inset(50%) !important;
    }
  `;e([n({type:String})],t.prototype,"value",void 0);e([n({type:String})],t.prototype,"placeholder",void 0);e([n({type:String})],t.prototype,"screenReaderLabel",void 0);e([n({type:String})],t.prototype,"clearButtonScreenReaderLabel",void 0);e([n({type:String})],t.prototype,"ariaControls",void 0);e([n({type:Boolean})],t.prototype,"focusOnClear",void 0);e([n({type:Boolean,reflect:!0})],t.prototype,"forceClearButton",void 0);e([c("#text-input")],t.prototype,"textInput",void 0);t=e([h("ia-clearable-text-input")],t);export{t as IaClearableTextInput};
//# sourceMappingURL=ia-clearable-text-input.mjs.map